import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const DownloadPresentation = ({
	isDownLoad,
	onStartDownload,
	onClose,
	collectionTitle,
	selectedProductIds,
	onDownload,
	isFolder = false,
	entityType = 'COLLECTION',
	setIsShowPresentationModal
}) => {
	const [collectionName, setCollectionName] = useState('');
	const [seasonName, setSeasonName] = useState('');
	const [market, setMarket] = useState('');
	const [selectedIds, setSelectedIds] = useState([]);
	const [isCheckedMoodboard, setIsCheckedMoodboard] = useState(false);
	const [errors, setErrors] = useState({
		collectionNameError: ''
	});
	let { id } = useParams();

	useEffect(() => {
		setCollectionName(collectionTitle);
		setSelectedIds(selectedProductIds);
	}, [collectionTitle, selectedProductIds]);

	const onSubmit = async () => {
		if (collectionName !== '') {
			onStartDownload();
			let body = {
				name: collectionName,
				market: market,
				presentationTemplate: 'TEMPLATE_ONE',
				productIdList: selectedIds,
				season: seasonName,
				withMoodboard: isCheckedMoodboard,
				entityType: entityType
			};
			if (id) {
				body.entityId = id;
			}
			await ApiClient.POST('downloadPpt', body)
				.then((response) => {
					if (response.data) {
						window.open(response.data, '_parent');
					}
					onDownload();
					if (setIsShowPresentationModal) {
						setIsShowPresentationModal(false);
					}
				})
				.catch((error) => {
					toastError(error.response.data.message);
				});
		} else {
			setErrors({
				collectionNameError: isFolder ? 'Input a Folder name' : 'Input a Collection name'
			});
			return;
		}
	};

	return (
		<Modal show={isDownLoad} onHide={onClose} backdrop="static" className="presentation-modal">
			<Modal.Header closeButton>
				<Modal.Title>
					<span className="semibold-16">Download presentation</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="form-group">
					<label>{isFolder ? 'Folder name' : 'Collection name'}</label>
					<input
						type="text"
						autoComplete="off"
						name="collectionName"
						className={`bg-gray-light border-0 ${errors.collectionNameError ? 'error2' : ''}`}
						value={collectionName}
						onChange={(e) => {
							setErrors({ ...errors, collectionNameError: '' });
							setCollectionName(e.target.value);
						}}
						placeholder={isFolder ? 'Type Folder name' : `Type Collection name`}
					/>
					{errors.collectionNameError ? (
						<span className="error">{errors.collectionNameError}</span>
					) : (
						''
					)}
				</div>
				<div className="form-group">
					<label>Season name</label>
					<input
						type="text"
						autoComplete="off"
						name="seasonName"
						className="bg-gray-light border-0"
						value={seasonName}
						onChange={(e) => setSeasonName(e.target.value)}
						placeholder="Type season"
					/>{' '}
				</div>
				<div className="form-group mb-0">
					<label>Market</label>
					<input
						type="text"
						autoComplete="off"
						name="market"
						className="bg-gray-light border-0"
						value={market}
						onChange={(e) => setMarket(e.target.value)}
						placeholder="Type market"
					/>{' '}
				</div>
				{!isFolder && (
					<div className="all-checkbox bg-gray-light select-all-designs">
						<div className="custom-chekbox">
							<div className="form-group m-0 mt-3">
								<input
									id="isCheckedMoodboard"
									type="checkbox"
									value={isCheckedMoodboard}
									onChange={() => setIsCheckedMoodboard(!isCheckedMoodboard)}
								/>
								<label htmlFor="isCheckedMoodboard" className="m-0">
									<span className="align-middle">Moodboard</span>
								</label>
							</div>
						</div>
					</div>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button className="presentation-btn size32" variant="primary" onClick={onSubmit}>
					Submit
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
export default DownloadPresentation;
